'use client';

import styled from 'styled-components';

import { Breakpoints, Col, Flex, Spacing } from '@zoomit/primitives';
import type { KeySpecification } from '@zoomit/web-kit';
import { IconRenderer, isMobile } from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

type Props = KeySpecification;

const SpecCol = (props: Props) => {
  const { primaryValue, secondaryValue, desktopIcon, mobileIcon } = props;

  return (
    <Root>
      <Flex flexDirection="column" justifyContent="center" gap={Spacing.x}>
        <Flex flexWrap={'nowrap'} alignItems={'center'} gap={0.4}>
          {isMobile
            ? mobileIcon.content && (
                <IconRenderer icon={mobileIcon.content} size="md" fill={cssVar(theme.grey1)} />
              )
            : desktopIcon.content && (
                <IconRenderer icon={desktopIcon.content} size="md" fill={cssVar(theme.grey1)} />
              )}
          <EllipsisText fontSize={1.2} lineHeight={2} lineCount={1} className="fa">
            {primaryValue}
          </EllipsisText>
        </Flex>
        <EllipsisText fontSize={1.2} textColor={cssVar(theme.grey1)} lineCount={1}>
          {secondaryValue}
        </EllipsisText>
      </Flex>
    </Root>
  );
};

export default SpecCol;

const Root = styled(Col)`
  max-width: 25%;
  flex: 0 0 25%;
  display: flex;
  gap: 1.6rem;

  @media (max-width: ${Breakpoints.md}) {
    background-color: var(${theme.background1});
    border-radius: var(${theme.radius.sm});
    padding: 8px 12px;
    flex: 0 0 calc(50% - 4px);
    max-width: calc(50% - 4px);
  }
`;

const EllipsisText = styled(Typography)<{ lineCount: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ lineCount }) => lineCount};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
`;
